/**
 * Parses search filters passed in via the URL query string so a link into a
 * CommonPage-based search screen (e.g. a home dashboard tile) can pre-set the
 * filters and have the search run automatically.
 *
 * @param {URLSearchParams} searchParams  the page's current query params
 * @param {string[]} multiFilterNames     names of multi-select filters to read;
 *                                         each accepts a comma-separated list
 * @returns {{name: string, val: any}[]}  filter items in the shape the toolbar
 *                                         and CommonPage.onSearch expect
 */
export const parsePresetFilters = (searchParams, multiFilterNames = []) => {
  const result = []

  multiFilterNames.forEach(name => {
    const raw = searchParams.get(name)
    if (raw) {
      const values = raw
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)
      if (values.length) result.push({ name, val: values })
    }
  })

  const term = searchParams.get("search_term")
  if (term) result.push({ name: "search_term", val: term })

  // A date range arrives as before_date (start) / after_date (end); both are
  // carried on the single "before_date" filter item as a custom range. Parse
  // yyyy-MM-dd as a local date (not UTC) so it round-trips to the same day.
  const toLocalDate = s => (s ? new Date(`${s}T00:00:00`) : null)
  const beforeDate = searchParams.get("before_date")
  const afterDate = searchParams.get("after_date")
  if (beforeDate || afterDate) {
    result.push({ name: "before_date", val: { mode: "CUSTOM", before_date: toLocalDate(beforeDate), after_date: toLocalDate(afterDate) } })
  }

  return result
}
